import React from 'react';
import style from "./style.module.scss";
import cx from 'classnames';

interface Props {
  illustration: any;
  illustrationAltText: string;
  icon: React.ReactNode;
  children: React.ReactNode;
}

export const HeaderWithIllustration: React.FC<Props> = (props) => {
  return <div className={cx(style.header, 'u-margin-B-m')}>
    <div>
      {props.icon}
      {props.children}
    </div>
    <div className={cx(style.illustration, 'u-padding-H-xl')}>
      <img src={props.illustration} alt={props.illustrationAltText}/>
    </div>
  </div>

}
